import { render, staticRenderFns } from "./FacebookGray.vue?vue&type=template&id=3bd11eca&scoped=true&"
import script from "./FacebookGray.vue?vue&type=script&lang=js&"
export * from "./FacebookGray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd11eca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd11eca')) {
      api.createRecord('3bd11eca', component.options)
    } else {
      api.reload('3bd11eca', component.options)
    }
    module.hot.accept("./FacebookGray.vue?vue&type=template&id=3bd11eca&scoped=true&", function () {
      api.rerender('3bd11eca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/icons/social/FacebookGray.vue"
export default component.exports